<template>
  <div class="talent-level-container">
    <div class="list-wrap">
      <div class="tile is-parent">
        <article class="tile is-child box set-container">
          <div>
            <button class="button is-success" @click="onShowAddGoods">新增单品</button>
          </div>
        </article>
      </div>
      <div class="goods-list" v-if="count > 0">
        <waterfall :column-width="300">
          <div class="waterfall-container">
            <div v-for="(item,index) in list" class="goods-container waterfall-item">
              <div class="goods-img">
                <image-component :image="item.image" :width="260"></image-component>
              </div>
              <div class="goods-info">
                <div class="goods-name">
                  <label class="label">{{item.name}}</label>
                  <span>库存{{item.stock}}</span>
                </div>
                <div>
                  <span>￥{{item.price}}</span>
                </div>
              </div>
              <div class="goods-bi">
                <span>浏览量 {{item.viewCount}}</span>
                <span>点击量 {{item.clickCount}}</span>
                <span>销量 {{item.soldCount}}</span>
              </div>
              <div class="btn-container">
                <a class="button is-info" :href="'/admin.php?method=goods.view&goodsId='+item.goodsId" target="_blank">编辑</a>
                <button class="button is-danger margin-left" @click="onDeleteArticleGoods(index)">删除</button>
              </div>
            </div>
          </div>
        </waterfall>
      </div>
      <el-dialog title="添加商品" :visible.sync="modal.visible" size="tiny" :lock-scroll="false">
        <div>
          <div class="block" v-for="(item,index) in 5">
            <div class="control">
              <label class="label  inline-block">商品ID:</label>
              <input v-if="modal.goods[index]" type="text" class="input width-2" v-model="modal.goods[index].goodsId">
            </div>
            <div class="control">
              <label class="label  inline-block">商品名称:</label>
              <input v-if="modal.goods[index]" type="text" class="input width-2" v-model="modal.goods[index].name">
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="modal.visible = false;">取 消</el-button>
          <el-button type="primary" @click="MODAL_OK_EVENT">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script type="text/babel">
  import waterfall from 'COMMON/waterfall/waterfall.vue'
  import {mapActions} from 'vuex';

  export default {
    components:{
      waterfall
    },
    data(){
      return {
        list:[],
        count:0,
        search:{
          page:1,
          pageSize:10,
          articleId:''
        },
        modal:{
          visible:false,
          goods:[]
        }
      }
    },
    watch:{
      "modal.visible"(){
        if(!this.modal.visible){
          this.modal.goods = [];
        }
      }
    },
    mounted(){
      this.getList();
      this.initData();
    },
    methods:{
      ...mapActions([
        'commitWaterfallUpdate'
      ]),
      initData(){
        for(let i = 0; i < 5; i++){
          this.modal.goods.push({
              "name":"",
              "goodsId":""
          });
        }
      },
      getList(){
        this.search = Object.assign(this.search,this.$route.query);
        HttpRequest.get('/admin.php?method=blogger.getArticleGoods',this.search).then(response => {
          this.count = 0;
          setTimeout(()=>{
            this.list = _.toArray(response.data.list);
            this.count = response.data.count ? response.data.count : _.size(response.data.list);
            this.commitWaterfallUpdate(true);
          },0)
        })
      },
      onDeleteArticleGoods(index){
        if(!confirm("确认删除?")){
          return false;
        }
        let params = {
          articleId:this.search.articleId,
          goodsIds:[this.list[index].goodsId]
        }
        HttpRequest.post('/admin.php?method=blogger.deleteArticleGoods',params).then(response => {
          if(response.data.success){
            this.$message("删除成功！");
            this.getList();
          }
        })
      },
      /**
       * 添加商品
       */
      onShowAddGoods(){
        this.modal.visible = true;
        this.initData();
      },
      handleCurrentChange(page){
        if(this.search.page !== page){
          this.search.page = page;
          this.getList();
        }
      },
      MODAL_OK_EVENT(){
        let goods = _.filter(this.modal.goods,item => {
          return (item.goodsId || item.name);
        })
        let params = {
          articleId:this.search.articleId,
          goods:goods
        }
        HttpRequest.post('/admin.php?method=blogger.doSaveArticleGoods',params).then(response => {
          if(response.data.success){
          	this.modal.visible = false
            this.getList();
          }
        })
      }
    }
  }
</script>
<style lang="less">
  .goods-container {
    position: relative;
    width: 300px;
    border: 1px solid #d3d6db;
    border-radius: 6px;
    background-color: #fff;
    padding:10px 20px;
    margin-top: 20px;
    .goods-img {
      width: 260px;
      height:200px;
      overflow: hidden;
      img {
        width:100%;
        height:100%;
        object-fit: cover;
        vertical-align: middle;
      }
    }
    .goods-info {
      padding: 10px 0;
      font-size: 16px;
      .goods-name {
        display: flex;
        justify-content: space-between;
        margin-bottom: 6px;
        label {
          width:180px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }
      }
    }
    .goods-bi {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-bottom: 10px;
    }
  }
</style>
